import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
    path: '/ticket',
    component: Layout2,
    meta: {
        zhtitle: zh.m.router.common.TICKET,
        jatitle: ja.m.router.common.TICKET,
        pername: 'order_ticket'
    },
    children: [{
        path: '',
        name: 'ticket',
        component: () => import( /* webpackChunkName: "jp.ticket" */ '@/merchanAdmin/ticket/list'),
        meta: {
            zhtitle: zh.m.router.common.TICKET,
            jatitle: ja.m.router.common.TICKET,
            pername: 'order_ticket'
        }
    }, {
        path: 'create',
        name: 'ticketcreate',
        component: () => import( /* webpackChunkName: "jp.ticket" */ '@/merchanAdmin/ticket/detail'),
        meta: {
            zhtitle: zh.m.router.common.CREATE,
            jatitle: ja.m.router.common.CREATE,
            pername: 'order_ticket'
        }
    }, {
        path: 'detail',
        name: 'ticketdetail',
        component: () => import( /* webpackChunkName: "jp.ticket" */ '@/merchanAdmin/ticket/detail'),
        meta: {
            zhtitle: zh.m.router.common.EDIT,
            jatitle: ja.m.router.common.EDIT,
            pername: 'order_ticket'
        }
    }]
}]